module.exports = __webpack_public_path__ + "img/img_shouye_appxiazai@2x.f850fc7e.png";